// ScaleQuestion.jsx
const DEFAULT_SCALE = [
  { label: 1, value: 0 },
  { label: 2, value: 25 },
  { label: 3, value: 50 },
  { label: 4, value: 75 },
  { label: 5, value: 100 },
];

export default function ScaleQuestion({
  question,
  value,
  onChange,
  name,
  required = true,
  disabled = false,
}) {
  const groupName = name ?? `question_${question.id}_scale`;

  return (
    <div>
      <div className="mb-6">
        <h3 className="h4">{question.title}</h3>
        {question.subtitle ? (
          <p className="prose mt-2">{question.subtitle}</p>
        ) : null}
      </div>

      {question.min_label !== '1' && question.max_label !== '5' ? (
        <div className="flex justify-between mb-4">
          <span className="text-sm">{question.min_label}</span>
          <span className="text-sm">{question.max_label}</span>
        </div>
      ) : null}

      <div className="grid grid-cols-5 gap-4 lg:gap-8">
        {DEFAULT_SCALE.map((opt) => {
          const checked = value === opt.value;
          return (
            <label
              key={opt.value}
              className={`transition-all relative flex items-center justify-center rounded-full aspect-square cursor-pointer border-4 text-xl lg:text-3xl
                hover:bg-pink-light hover:border-purple
                ${checked ? 'border-purple bg-pink-light font-bold' : 'border-white bg-white'}
                ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
            >
              <input
                type="radio"
                className="sr-only"  // keep it focusable & accessible
                name={groupName}
                value={opt.value}
                checked={checked}
                onChange={() => onChange(opt.value)}
                required={required}
                disabled={disabled}
              />
              <span aria-hidden="true">{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
